import React from 'react';

class FormatoSimplificado1347566PlanPremiumPlusS_pdf extends React.Component {
    componentDidMount() {
        let event = new Event('js');
        window.dispatchEvent(event);
        document.title = 'Red Itmex - Documentacion - Formato Simplificado 1347566 Plan Premium + SIMÉTRICO';
        this.abrirPdf()
    }
    abrirPdf = () => {
        window.location.href = 'https://firebasestorage.googleapis.com/v0/b/reditmextrescero.appspot.com/o/datasheets%2Flegal%2FITMEX_FORMATO_SIMPLIFICADO_1347566_PREMIUM%2BS_2024_V1.pdf?alt=media&token=577fe42d-5564-40aa-b74b-86aade535f7b';
    }
    render() {
        return (
            <div>Loading...</div>
        )
    }
}
export default FormatoSimplificado1347566PlanPremiumPlusS_pdf